import { LoadingController, ModalController, IonicModule } from '@ionic/angular';
import { Component, OnChanges, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { GenericRouteEvent } from 'src/app/types/normalize/generic-route-event.model';
import { FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification.service';
import { TranslateService } from 'src/app/services/translate.service';
import { AddressComponent } from '../../../components/address/address.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './group-on-the-way.dialog.html',
  styleUrls: ['./group-on-the-way.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonicModule, FormsModule, ReactiveFormsModule, AddressComponent, TranslatePipe],
})
export class GroupOnTheWayDialog implements OnInit, OnChanges {
  private readonly modalController = inject(ModalController);
  private readonly loadingController = inject(LoadingController);
  private readonly translateService = inject(TranslateService);
  private readonly notificationService = inject(NotificationService);

  public routeEvents: GenericRouteEvent[] = [];
  public submitting = false;

  public readonly form = new FormArray<RouteEventGroup>([]);

  createGroup(routeEvent: GenericRouteEvent): RouteEventGroup {
    return new FormGroup({
      routeEvent: new FormControl<GenericRouteEvent>(routeEvent),
      selected: new FormControl<boolean>(true),
    });
  }

  updateForm(): void {
    this.form.clear();
    this.routeEvents
      .sort((a, b) => b.groupStopOrder - a.groupStopOrder)
      .forEach(re => {
        this.form.push(this.createGroup(re));
      });
  }

  ngOnInit(): void {
    this.updateForm();
  }

  ngOnChanges(): void {
    this.updateForm();
  }

  public onCancel(): void {
    this.modalController.dismiss();
  }

  public async onSubmit(): Promise<void> {
    const loading = await this.loadingController.create({
      spinner: 'crescent',
      message: this.translateService.translate('MESSAGE.patience'),
      backdropDismiss: false,
    });
    try {
      this.submitting = true;
      await loading.present();
      const selected = this.form.getRawValue().filter(job => job.selected);
      await Promise.all(selected.map(selected => selected.routeEvent.onTheWay()));
      await loading.dismiss();
      this.modalController.dismiss();
    } catch (error) {
      await loading.dismiss();
      await this.notificationService.error(error?.message || error, null, true);
    } finally {
      this.submitting = false;
    }
  }
}

type RouteEventGroup = FormGroup<{
  routeEvent: FormControl<GenericRouteEvent>
  selected: FormControl<boolean>
}>
